import { useCallback } from 'react';

import { FamilyTreeActionFn, UpdateVisualizationConfigAction } from '../types';

export function useUpdateVisualizationConfigAction() {
  return useCallback<FamilyTreeActionFn<UpdateVisualizationConfigAction>>(
    (state, action, queueEffect) => {
      const updatedConfig = {
        ...state.visualizationConfig,
        [action.key]: action.value,
      };

      // Queue effect to save the visualization config
      queueEffect({
        type: 'saveVisualizationConfigEffect',
        householdId: state.householdId,
        originalConfig: state.visualizationConfig,
        config: updatedConfig,
      });

      return {
        ...state,
        visualizationConfig: updatedConfig,
      };
    },
    []
  );
}
